import { get, writable } from "svelte/store";
import { Dictionary } from "../../../../../shared/Dictionary";
import { appManager } from "../../../../../AppManager";
/**
 * Manages an origin-destination matrix.
 */
export class MatrixManager {
    constructor(parent, tripScenarioId, matrix) {
        this.movementsByKey = new Dictionary();
        this.parent = parent;
        this.tripScenarioId = tripScenarioId;
        this.matrix = matrix;
        this.locations = writable(this.matrix.locations);
        this.elements = writable(this.matrix.elements);
        this.name = writable(this.matrix.name);
        this.name.subscribe(v => {
            if (this.matrix.name == v)
                return;
            this.matrix.name = v;
            this.save().then();
        });
        this.onMovementsChanged(this.matrix.elements);
        this.elements.subscribe(mvs => this.onMovementsChanged(mvs));
    }
    onMovementsChanged(mvs) {
        mvs.forEach(m => {
            const locations = get(this.locations);
            const fromId = locations[m.fromIdx].id;
            const toId = locations[m.toIdx].id;
            this.movementsByKey.set(`${fromId}-${toId}`, m);
        });
    }
    async save() {
        const token = await appManager.api.getAccessToken();
        const result = await appManager.api.projects.updateMatrix({
            tripScenarioId: this.tripScenarioId,
            id: this.matrix.id,
            data: {
                name: this.matrix.name
            },
            accessToken: token
        });
    }
    /**
     * Updates the data in this matrix manager.
     *
     * @param data
     */
    updateData(data) {
        this.matrix.locations = data.locations;
        this.matrix.elements = data.elements;
        this.locations.set(this.matrix.locations);
        this.elements.set(this.matrix.elements);
    }
    /**
     * Gets the original od matrix.
     *
     * @returns
     */
    getData() {
        return this.matrix;
    }
    /**
     * Gets the movement for an od-pair.
     */
    getMovement(movementKey) {
        return this.movementsByKey.get(movementKey);
    }
}
